export const temAtendimentoVolumeIguais = (ucs, tipo) => {
  return ucs?.every(
    uc =>
      uc.propostaCargaPeriodo.every(pcp => pcp[tipo] === uc.propostaCargaPeriodo[0][tipo]) &&
      (tipo === 'atendimentoCarga' ? uc.propostaCargaPeriodo[0][tipo] === ucs[0].propostaCargaPeriodo[0][tipo] : true),
  );
};
